export default function ({state}, value) {
    state.addFields = value;
}
